import { apiClient } from './client'
import type { User } from '@/types/auth'

export interface LoginPayload {
  email: string
  password: string
}

export interface LoginResponse {
  user: User
}

export const authApi = {
  login: (payload: LoginPayload): Promise<LoginResponse> =>
    apiClient.post<LoginResponse>('/auth/login', payload).then((r) => r.data),

  logout: (): Promise<void> => apiClient.post('/auth/logout').then(() => undefined),

  me: (): Promise<User> => apiClient.get<User>('/auth/me').then((r) => r.data),
}
